export const Bio = {
  name: " Ram Tiwari",
  roles: ["Full Stack Developer ", "Software Engineer", "Backend Specialist"],
  description:
    "I am a Full Stack Developer specializing in .NET technologies and PHP. My expertise includes .NET Core, ASP.NET, ADO.NET, MVC, and Laravel. I am skilled in developing robust web applications, managing databases (SQL Server, MySQL), and building efficient, scalable backend solutions. I also have experience with frontend technologies such as Angular, Blazor, and .NET MAUI, along with deploying applications on Azure and IIS. Skilled in containerization with Docker and experienced in using Azure DevOps for source control, work item tracking, and CI/CD pipelines, enabling automated builds, deployments, and smooth collaboration across development and testing environments. Committed to Agile methodologies, I focus on delivering high-quality, optimized performance.",
  github: "https://github.com/RamTiwari16",
  resume:
    "https://drive.google.com/file/d/138-mKdIycO6u8x7rgEldhdQQ3vOI68n3/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/tiwariram",
  insta: "https://www.instagram.com/illati_ram?igsh=MW5yMzc0cjhnNzYwMQ==",
  facebook: "https://www.facebook.com/ramtiwari.tiwari.39?mibextid=ZbWKwL",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "Blazor",
        image:
          "https://devblogs.microsoft.com/aspnet/wp-content/uploads/sites/16/2019/04/BrandBlazor_nohalo_1000x.png",
      },
      {
        name: "Angular",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Angular_full_color_logo.svg/2048px-Angular_full_color_logo.svg.png",
      },
      {
        name: ".Net MAUI",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcStEOgD_09wR9-eiSwlgMW0Cfz5ov2FaIvjWA&s",
      },

      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",

      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },

      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Ajex",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyeFQiFyBnn5akpDiOGXBqbDHIDQe2jI5H8A&s",
      },

    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "C#",
        image:
          "https://cdn.imgbin.com/19/5/9/imgbin-c-programming-language-logo-microsoft-visual-studio-net-framework-javascript-icon-x2vvzpHKBmQaYkXV2vQ67GPY7.jpg",
      },
      {
        name: "Python",
        image:
          "https://w7.pngwing.com/pngs/234/329/png-transparent-python-logo.png",
      },
      {
        name: "Php",
        image:
          "https://w7.pngwing.com/pngs/576/407/png-transparent-php-software-development-kit-logo-node-js-programmer-others-miscellaneous-emblem-text.png",
      },
      {
        name: "C++",
        image:
          "https://w7.pngwing.com/pngs/579/803/png-transparent-the-c-programming-language-programmer-computer-programming-programming-blue-logo-computer-program.png",
      },
      {
        name: ".Net",
        image:
          "https://e7.pngegg.com/pngimages/722/584/png-clipart-net-framework-microsoft-windows-7-die-technische-referenz-microsoft-corporation-logo-agile-methodology-overview-text-teal-thumbnail.png",
      },
      {
        name: "MSSQL",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXzsfifIMvcAUOS6gFGyCz4yBnLrnMfyV0LQ&s",
      },
      {
        name: "MYSQL",
        image:
          "https://w7.pngwing.com/pngs/717/111/png-transparent-mysql-round-logo-tech-companies-thumbnail.png",
      },
      {
        name: ".Net Core",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/.NET_Core_Logo.svg/2048px-.NET_Core_Logo.svg.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "VisualStudio",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Visual_Studio_Logo_%282013-2017%29.svg/990px-Visual_Studio_Logo_%282013-2017%29.svg.png",
      },
      {
        name: "Docker",
        image:
          "https://www.vhv.rs/dpng/d/57-571004_docker-logo-hd-png-download.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },

      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://w7.pngwing.com/pngs/28/245/png-transparent-postman-hd-logo-thumbnail.png",
      },
      {
        name: "Azure",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQtEi1p2QQ5NyGxcKRCuyMQYrI6V4OG-SL7w&s",
      },
      {
        name: "SQL Server Reporting Services",
        image:
          "https://avdbrink.gallerycdn.vsassets.io/extensions/avdbrink/vsts-ssrs/0.2.6/1566215698194/Microsoft.VisualStudio.Services.Icons.Default",
      },
    ],
  },


];

export const experiences = [
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/D560BAQER6dUVut2nOA/company-logo_200_200/company-logo_200_200/0/1732880602645?e=2147483647&v=beta&t=p8EF9ZQSOAl0LoN3EHUHdpi55SVIv03EZ0ls-Ske3MM", // Replace with Xtra4 logo
    role: ".NET Full Stack Developer",
    company: "Xtra4 Technologies Pvt. Ltd.",
    date: "July 2026 – Present",
    desc: "Working as a .NET Full Stack Developer on the enterprise product iXChek. Developing and maintaining scalable web applications using ASP.NET Core and Angular. Building AI/ML-powered Retrieval-Augmented Generation (RAG) solutions by integrating Large Language Models (LLMs) with enterprise data. Developing REST APIs, deploying applications with Docker, and working with YugabyteDB in a multi-cluster distributed database environment. Leveraging AI-assisted development tools such as Claude Code and Cursor to improve development speed and code quality.",
    skills: [
      "ASP.NET Core",
      "Angular",
      "C#",
      ".NET Core",
      "REST APIs",
      "AI",
      "Machine Learning",
      "RAG",
      "Large Language Models (LLMs)",
      "Docker",
      "YugabyteDB",
      "Multi-Cluster Database",
      "Claude Code",
      "Cursor"
    ],
  }
  ,
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlE9UFEFHtgj7clGaR7jA4Dm1lGpzHCoNQGA&s",
    role: "Software Engineer",
    company: "QSix India Private Limited",
    date: " April 2025 – july 2026",
    desc: "At QSix India Pvt Ltd as an Angular and ASP.NET Core Developer for the client SIS Procedure. Involved in building responsive frontend interfaces using Angular and developing secure, efficient backend services with .NET Core, ADO.NET, and SQL Server.",
    skills: [

      "Angular",
      "Ado.Net",
      "ASP.NET",
      "Problem Solving",
      "HTML5",
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
      ".NET Core",
      "RESTful APIs",
      "C#",
      "C++",
      "SQL Server",
      "MSSQL",
      "Entity Framework",
      "AWS",
      "Azure DevOps",
      "Code Reviews",
      "Test-Driven Development (TDD) using NUnit",
      "GIT",
    ]
    ,
    // doc: "https://docs.google.com/document/d/1NdXjPUPEujQS2WGdSKgM1XyblN65mu9ZkuUTBS91_80/edit?usp=sharing",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRT366b5ZXMj2kHvwLl5QRQnNK956hGnxVGyA&s",
    role: "Software Engineer",
    company: "Rikarena Consultancy Private Limited",
    date: " Jan 2023 – April 2025 ",
    desc: "In Rikarena Consultancy Private Limited I focus on backend development and have successfully deployed several projects on AWS And include designing and implementing scalable and secure backend solutions ",
    skills: [


      "ASP.NET",
      "Problem Solving",
      "HTML5",
      "Data Structures and Algorithms",
      "Database Management System (DBMS)",
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",

      "Computer Networking",

      ".NET Core",
      "RESTful APIs",
      "C#",
      "C++",
      "Python",
      "SQL Server",
      "MySQL",
      "Entity Framework",
      "AWS",
      "Azure DevOps",
      "Code Reviews",
      "Test-Driven Development (TDD) using NUnit",
      "GIT",
      "Agile/Scrum methodology",

      "Puppeteer"
    ]
    ,
    // doc: "https://docs.google.com/document/d/1NdXjPUPEujQS2WGdSKgM1XyblN65mu9ZkuUTBS91_80/edit?usp=sharing",
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeeZhNinI7lBAwNojNYaSV9V2CujZGGWhIPA&s",
    school: "Amity University",
    date: "2025 -2027 ",
    grade: "",
    desc: "Master of Computer Applications (MCA) from Amity University with a specialization in Artificial Intelligence and Machine Learning",
    degree: "MCA (Pursuing )",
  },
  {
    id: 1,
    img: "https://d1fdloi71mui9q.cloudfront.net/Naxs310XSx23wHjYQByt_13bRUl2fsk8j2Y1m",
    school: " Kalinga University, Raipur",
    date: "2021 ",
    grade: "8.71 CGPA",
    desc: "I am Bachelor of Computer Applications graduate specialization in Computer Science and Engineering from Kalinga University, Raipur. I extensively studied subjects such as Data Structures and Algorithms (DSA), SQL, Database Management Systems (DBMS), Web Technology, Python,C,C# and IOT etc.",
    degree: "Bachelor of Computer Applications, Computer Science and Engineering",
  },
  {
    id: 2,
    img: "https://th.bing.com/th/id/OIP.6_Q1a6FzrY2QNxFJQZLEMQHaHa?w=134&h=150&c=7&r=0&o=5&pid=1.7",
    school: "Govt Inter College ,Fatehpur ",
    date: "2018",
    grade: "70%",
    desc: "I completed my class 12 high school education at Govt Inter College ,Fatehpur.",
    degree: "(XII), PCM",
  },
  {
    id: 3,
    img: "https://psebfiles.s3.ap-south-1.amazonaws.com/uploads/1648628722_PSEBlogo_2.png",
    school: " VishavKarma Sen Sec School, Ludhiana",
    date: "2016",
    grade: "85.3%",
    desc: "I completed my class 10 education at  VishavKarma Sen Sec School, Ludhiana.",
    degree: "(X), Science with Computer",
  }

];
//testing

export const Certificates = [
  {
    id: 0,
    img: "https://cdn-icons-png.flaticon.com/512/8133/8133849.png",
    school: "PDCTT ",
    date: "2021 ",
    desc: "The Professional Diploma in Computer Teacher Training (PDCTT) equips educators with advanced computer skills and teaching methodologies, preparing them for impactful careers in education. "

  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeeZhNinI7lBAwNojNYaSV9V2CujZGGWhIPA&s",
    school: "Basic of AI(Amity University) ",
    date: "2025 ",
    desc: "Completed a certification in Basics of Artificial Intelligence, covering core AI concepts, machine learning fundamentals, and real-world applications."

  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeeZhNinI7lBAwNojNYaSV9V2CujZGGWhIPA&s",
    school: "Future of computing (Amity University) ",
    date: "2025 ",
    desc: "Completed a certification in Basics of Artificial Intelligence, covering core AI concepts, machine learning fundamentals, and real-world applications."

  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeeZhNinI7lBAwNojNYaSV9V2CujZGGWhIPA&s",
    school: "Professional and Life Skill(Amity University) ",
    date: "2025 ",
    desc: "Completed a certification in Basics of Artificial Intelligence, covering core AI concepts, machine learning fundamentals, and real-world applications."

  }
];

export const education1 = [
  {
    id: 0,
    img: "https://d1fdloi71mui9q.cloudfront.net/Naxs310XSx23wHjYQByt_13bRUl2fsk8j2Y1m",
    school: " Kalinga University, Raipur",
    date: "2021 ",
    grade: "8.71 CGPA",
    desc: "I am Bachelor of Computer Applications graduate specialization in Computer Science and Engineering from Kalinga University, Raipur. I extensively studied subjects such as Data Structures and Algorithms (DSA), SQL, Database Management Systems (DBMS), Web Technology, Python,C,C# and IOT etc.",
    degree: "Bachelor of Computer Applications, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://th.bing.com/th/id/OIP.6_Q1a6FzrY2QNxFJQZLEMQHaHa?w=134&h=150&c=7&r=0&o=5&pid=1.7",
    school: "Govt Inter College ,Fatehpur ",
    date: "2018",
    grade: "70%",
    desc: "I completed my class 12 high school education at Govt Inter College ,Fatehpur.",
    degree: "(XII), PCM",
  },
  {
    id: 2,
    img: "https://bingo.icbse.com/business.jpg?action=logo&id=pmexk",
    school: " VishavKarma Sen Sec School, Ludhiana",
    date: "2016",
    grade: "85.3%",
    desc: "I completed my class 10 education at  VishavKarma Sen Sec School, Ludhiana.",
    degree: "(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 14,
    title: "C3R – Compliance and Case Review System",
    date: "April 2025 - Present",
    description:
      "• Currently working on the C3R project using Angular 19 and ASP.NET Core for front-end and back-end development • Implemented secure Web APIs with JWT authentication for data exchange between client and server.• Utilized ADO.NET Core and stored procedures for efficient data operations and business logic execution.• Integrated SQL Server Management Studio (SSMS) for database management and reporting.• Collaborated on developing dynamic user interfaces using Angular and ensured responsive, high-performing applications.• Focused on building a scalable and secure system architecture to support complex compliance workflows.",
    image: "https://www.sisprosegur.com/dam/jcr:6a834059-feb8-44ad-b4ef-27ca6e6f2d5f/Nuevo%20logo.svg",

    category: "web app",
    tags: [
      "Angular",
      "Ado.Net",
      "Web-API",
      ". Net Core",
      "MSSQl",
      "Azure",
      "C#",
      ".Net",
    ],
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://6572e3c66087886c4d0f0f8c--tyagikalash.netlify.app/",
  },
  {
    id: 10,
    title: "CustOS - Asset Management Software",
    date: "Mar 2023 - Aug 2023",
    description:
      "CustOS is a Windows application designed for comprehensive asset management within a company, including system security and tracking. It features an admin console, background services for firewall management, and is built using C# and .NET technology.",
    image: "https://media.licdn.com/dms/image/v2/C510BAQG5J-NJyMepNg/company-logo_200_200/company-logo_200_200/0/1630634004547/rikarena_consultancy_pvt_ltd_logo?e=1750291200&v=beta&t=Y5XdFl78kKbD1-DiAjhOopfIuIduD_94c3SLgovta_U",
    tags: [
      "C#",
      ".NET Framework",
      "Blazor",
      "Windows Application Development",
      "RESTful APIs",
      "Background Services",
      "Firewall Management",
      "Asset Management",
      "Admin Console Development",
      "SQL Server",
      "System Security"
    ]
    ,
    category: "Windows App",
    github: "#",
    webapp: "http://80.209.230.117:8002/",
  },
  {
    id: 11,
    title: "HDFC - Complainces Project",
    date: "Feb 2024 - May 2024",
    description:
      "Spearheaded the development of a robust web application using ASP.NET Core, Entity Framework Core, and Angular, delivering a modern user experience and enhancing overall efficiency.Designed and implemented complex database schemas using MSSQL Server, optimizing query performance and data integrity for seamless application functionality.Developed RESTful APIs to facilitate communication between frontend and backend systems, enabling seamless data exchange and integration with third-party services.Implemented authentication and authorization mechanisms using JWT tokens, ensuring secure access to application resources andprotecting sensitive data.Developed scalable and robust REST API solutions, resolving backend bottlenecks.Prepared documentation for API integration with the frontend.Deployed and set up AWS environment using AWS Elastic Beanstalk and RDS",
    image: "https://static.vecteezy.com/system/resources/previews/020/190/432/original/hdfc-logo-hdfc-icon-free-free-vector.jpg",

    category: "web app",
    tags: [
      ".Net",
      "Web-API",
      ". Net Core",
      "MSSQl",
      "Aws",
      "C#",
    ],
    // github: "https://github.com/rishavchanda/Trackify",
    //  webapp: "http://80.209.230.117:7005/",
  },
  {
    id: 12,
    title: "AlSadique -  Mobile Application",
    date: "Nov 2024 - Feb 2025",
    description:
      "Developed and maintained a feature-rich mobile application for Al Sadique, a platform connecting users with deals and opportunities. The application enables seamless browsing, management, and interaction with deals while supporting authentication and real-time updates.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRk-PxiYVoT_yglCIPRtEUgelgCDI_bQQglqg&s",

    category: "Mobile app",
    tags: [
      ".Net MAUI",
      ".Net",
      "Web-API",
      "Sieve",
      "Community Toolkit",
      ". Net Core",
      "MSSQl",

      "C#",
    ],
    // github: "https://github.com/rishavchanda/Trackify",
    webapp: "http://80.209.230.117:7005/",
  },
  {
    id: 13,
    title: "Al Sadique(Backend Developer)- Web Application Project",
    date: "Nov 2024 - Feb 2025",
    description:
      "Developed and maintained a comprehensive service management system designed to connect contractors, laborers, and clients based on required skills and services. The platform streamlines the discovery, matching, and management of service providers and products, ensuring efficiency and scalability.  Service and Product Integration: Designed APIs to fetch and filter public services and products dynamically, implementing advanced filtering mechanisms using Sieve for sorting and pagination.Entity Mapping and Relationships: Utilized AutoMapper to map complex relationships between contractors, laborers, and address book data to shared DTOs, ensuring maintainability and reusability. Skill-Based User Matching: Implemented business logic to match users (contractors and laborers) based on skill sets linked to specific services, ensuring accurate and efficient results.",
    image: "http://80.209.230.117:7005/assets/img/icons/logo.png",

    category: "web app",
    tags: [
      ".Net",
      ".Net Core",
      "Web-API",
      "Git",
      "Entity Framework",
      "MSSQl",
      "Azure",
      "C#",
    ],
    // github: "https://github.com/rishavchanda/Trackify",
    // webapp: "https://6572e3c66087886c4d0f0f8c--tyagikalash.netlify.app/",
  },

  {
    id: 9,
    title: "Corporate Infotech Pvt. Ltd - RMS",
    date: "Jan 2024",
    description:
      "I developed a Recruitment Management System (RMS) using Laravel and Eloquent ORM, handling extensive candidate data including personal details, education, and job information. I implemented a bulk upload feature to automate data entry from Excel, ensuring accurate validation and mapping. I designed an email notification system with Blade templates to send status updates to candidates, incorporating styled disclaimers for a professional touch. Additionally, I built a candidate insights dashboard to display metrics on candidate statuses and project counts. By maintaining detailed candidate history and logging actions, I ensured comprehensive records. I configured SMTP for Rediffmail, resolving authentication issues to enable reliable email functionality. Throughout the project, I utilized Laravel request validation for dynamic and accurate data handling..",
    image: "https://images.thinvent.in/wp-content/uploads/corporate-infotech-pvt-ltd-Neo-S.webp",
    tags: ["React Js", "Web Api", "PHP", "Laravel", "MySQL"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Trackify",
    webapp:
      "http://65.1.26.217:8082/",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
